import React, { Component } from 'react';
import { Checkbox } from 'react-bootstrap';
import { SUBMISSION_UPDATE } from '../../constants/submission';
import { updateWorkflowLimitChange } from '../actions';
import { connect } from 'react-redux';

class BaseRateCheck extends Component {
    constructor(props) {
      super(props);
      this.props = props;
      this.state = {
        submission: this.props.submission,
        isMinPremium: this.props.submission.isMinPremium
      };
    }

    handleMinPremChange = (event) => {
        let updatedSubmission = this.state.submission;
        updatedSubmission.isMinPremium = event.target.checked;
        this.setState({
            isMinPremium: event.target.checked
        });
        Object.assign(this.state.submission, updatedSubmission);
        this.props.updateWorkflowLimitChange(event.target.checked);
    }

    render() {
        let checkMinPremium = this.state.submission.isMinPremium == 'undefined' ? false : this.state.submission.isMinPremium;
        return(
           <div>
               <Checkbox
                checked={checkMinPremium}
                onChange={this.handleMinPremChange}
                className="mleft_10"
                >  
                <div className="check_rate">
                    Rate with Minimum Premium
                </div>
                </Checkbox>
            </div>
        )
    }
}

export default connect(null, { updateWorkflowLimitChange })(BaseRateCheck)